__turbopack_context__.v({
  "backdrop": "_2vR19W_backdrop",
  "backdropHidden": "_2vR19W_backdropHidden",
  "baseFieldItem": "_2vR19W_baseFieldItem",
  "content": "_2vR19W_content",
  "dropdownWrapper": "_2vR19W_dropdownWrapper",
  "icon": "_2vR19W_icon",
  "item": "_2vR19W_item" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "itemIndicator": "_2vR19W_itemIndicator",
  "selectGroup": "_2vR19W_selectGroup",
  "slideInFromBottom": "_2vR19W_slideInFromBottom",
  "slideInFromLeft": "_2vR19W_slideInFromLeft",
  "slideInFromRight": "_2vR19W_slideInFromRight",
  "slideOutToBottom": "_2vR19W_slideOutToBottom",
  "slideOutToLeft": "_2vR19W_slideOutToLeft",
  "slideOutToRight": "_2vR19W_slideOutToRight",
  "trigger": "_2vR19W_trigger" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "validationIcon": "_2vR19W_validationIcon",
});
